export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: '操作',
    align: 'center',
    width: 50,
    slots: { default: 'opt' }
  },
  {
    title: '文档名称',
    field: 'fileName',
    align: 'left',
    slots: { default: 'showItem' }
  }
]
